import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Chat } from "../../models/chat.model";
import * as firebase from "firebase";

@Injectable()
export class FirebaseActions {
  /* Firebase conversations list reference */
  private conversationListRef: any;
  /* Conversation ID prefix reference to conversation table */
  prefix = "c_";

  constructor(private db: AngularFireDatabase) {}

  getConversationList(conversation_id) {
    return this.db.list<Chat>(this.prefix + conversation_id);
  }

  replyConversation(chat: Chat, conversation_id) {
    return this.db.list<Chat>(this.prefix + conversation_id).push(chat);
  }

  removeConversation(conversation_id) {
    //return this.conversationListRef.remove(id);
  }

  removeConversationReply(id) {
    return this.conversationListRef.remove(id);
  }

  getSomeText() {
    return firebase
      .storage()
      .ref()
      .child("some text")
      .getDownloadURL()
      .then(response => response)
      .catch(error => console.log("error", error));
  }

  storeImage(imageData, imageName) {
    return new Promise((resolve, reject) => {
      const picture = firebase.storage().ref("pictures/" + imageName);
      picture.putString(imageData, "data_url").then(function(result) {
        picture.getDownloadURL().then(function(url) {
          resolve(url)
        });
      });
    }).catch(function() {});
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase-actions/firebase-actions.ts